document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-rr-menu]');
  if (!button) return;
  const menu = document.querySelector('[data-rr-links]');
  const open = menu?.classList.toggle('is-open');
  button.setAttribute('aria-expanded', String(Boolean(open)));
  document.body.classList.toggle('vg-nav-open', Boolean(open));
});

/* Collection type filters (?tipo=) */
(function () {
  const root = document.querySelector('[data-vg-collection]');
  if (!root) return;
  const cards = [...root.querySelectorAll('[data-vg-type]')];
  if (!cards.length) return;
  const params = new URLSearchParams(window.location.search);
  const tipo = params.get('tipo') || '';
  const countEl = root.querySelector('[data-vg-collection-count]');
  const emptyEl = root.querySelector('[data-vg-filter-empty]');
  let shown = 0;
  cards.forEach((card) => {
    const match = !tipo || card.getAttribute('data-vg-type') === tipo;
    card.hidden = !match;
    if (match) shown += 1;
  });
  if (countEl && tipo) countEl.textContent = shown + ' prodotti';
  if (emptyEl) emptyEl.hidden = !(tipo && shown === 0);
  const reset = root.querySelector('[data-vg-filter-reset]');
  if (reset) reset.hidden = !tipo;
  root.querySelectorAll('[data-vg-type-filter]').forEach((link) => {
    if (link.getAttribute('data-vg-type-filter') === tipo) link.setAttribute('aria-current', 'true');
  });
})();

/* Collection drawers */
(function () {
  const openFilters = document.querySelector('[data-vg-open-filters]');
  const openSort = document.querySelector('[data-vg-open-sort]');
  const filters = document.getElementById('VgFiltersDrawer');
  const sort = document.getElementById('VgSortDrawer');

  function closeAll() {
    [filters, sort].forEach((drawer) => {
      if (!drawer) return;
      drawer.hidden = true;
    });
    openFilters?.setAttribute('aria-expanded', 'false');
    openSort?.setAttribute('aria-expanded', 'false');
  }

  function openDrawer(drawer, trigger) {
    closeAll();
    if (!drawer) return;
    drawer.hidden = false;
    trigger?.setAttribute('aria-expanded', 'true');
  }

  openFilters?.addEventListener('click', () => openDrawer(filters, openFilters));
  openSort?.addEventListener('click', () => openDrawer(sort, openSort));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-vg-close-drawer]')) closeAll();
    if (event.target.matches('[data-vg-drawer]')) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();

/* PDP variant pills + thumbs + sticky ATC */
(function () {
  const root = document.querySelector('[data-vg-pdp]');
  if (!root) return;
  const form = root.querySelector('[data-vg-product-form]') || root.querySelector('form[action*="/cart/add"]');
  const idInput = root.querySelector('[data-vg-variant-id]');
  const variantSelect = root.querySelector('[data-vg-variant-select]');
  const atc = root.querySelector('[data-vg-atc]');
  const priceWrap = root.querySelector('[data-vg-price-wrap]');
  const saleChip = root.querySelector('[data-vg-sale-chip]');
  const sticky = document.querySelector('[data-vg-sticky-atc]');
  const stickySubmit = document.querySelector('[data-vg-sticky-submit]');
  const stickyPrice = document.querySelector('[data-vg-sticky-price]');
  const mainMedia = root.querySelector('[data-vg-main-media] img');

  function money(cents) {
    const value = Number(cents || 0) / 100;
    try { return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return value.toFixed(2).replace('.', ',') + ' €'; }
  }

  function renderPrice(priceValue, compareValue) {
    const price = Number(priceValue || 0);
    const compare = Number(compareValue || 0);
    const onSale = compare > price && price > 0;
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (saleChip) saleChip.hidden = !onSale;
    if (!priceWrap) return;
    if (onSale) {
      const saving = compare - price;
      const pct = Math.round((saving * 100) / compare);
      priceWrap.innerHTML = '<div class="vg-price vg-price--sale">' +
        '<p class="vg-price__now"><span class="vg-price__label">Ora</span> <strong>' + money(price) + '</strong></p>' +
        '<p class="vg-price__was"><span class="vg-price__label">Prima</span> <s>' + money(compare) + '</s></p>' +
        '<p class="vg-price__save">Risparmi ' + money(saving) + '</p>' +
        (pct > 0 ? '<p class="vg-price__pct">−' + pct + '%</p>' : '') + '</div>';
    } else {
      priceWrap.innerHTML = '<div class="vg-price"><p class="vg-price__now"><span class="vg-price__label">Prezzo</span> <strong>' + money(price) + '</strong></p></div>';
    }
  }

  function setMainImage(src, srcset) {
    if (!mainMedia || !src) return;
    mainMedia.src = src;
    if (srcset) mainMedia.srcset = srcset;
  }

  function setAvailability(available) {
    const canBuy = available === true || available === 'true';
    if (atc) { atc.disabled = !canBuy; atc.textContent = canBuy ? 'Aggiungi al carrello' : 'Esaurito'; }
    if (stickySubmit) {
      stickySubmit.disabled = !canBuy;
      stickySubmit.textContent = canBuy ? 'Aggiungi' : 'Esaurito';
    }
  }

  function applyVariant(data) {
    if (!data || !data.variantId) return;
    if (idInput) idInput.value = data.variantId;
    renderPrice(data.price, data.compare);
    setAvailability(data.available);
    if (data.mediaSrc) setMainImage(data.mediaSrc, data.mediaSrcset || '');
    const url = new URL(window.location.href);
    url.searchParams.set('variant', data.variantId);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-vg-variant-pills] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-vg-variant-pills] button').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyVariant({ variantId: btn.dataset.variantId, price: btn.dataset.price, compare: btn.dataset.compare, available: btn.dataset.available, mediaSrc: btn.dataset.mediaSrc, mediaSrcset: btn.dataset.mediaSrcset });
    });
  });

  variantSelect?.addEventListener('change', () => {
    const opt = variantSelect.selectedOptions[0];
    if (!opt) return;
    applyVariant({ variantId: opt.value, price: opt.dataset.price, compare: opt.dataset.compare, available: opt.dataset.available, mediaSrc: opt.dataset.mediaSrc, mediaSrcset: opt.dataset.mediaSrcset });
  });

  root.querySelectorAll('[data-vg-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      root.querySelectorAll('[data-vg-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setMainImage(thumb.dataset.fullSrc, thumb.dataset.fullSrcset || '');
    });
  });

  if (sticky && atc) {
    let atcVisible = true;
    let footerVisible = false;
    const syncSticky = () => {
      const show = !atcVisible && !footerVisible;
      sticky.hidden = !show;
      sticky.classList.toggle('is-on', show);
    };
    const io = new IntersectionObserver((entries) => {
      atcVisible = entries.some((e) => e.isIntersecting);
      syncSticky();
    }, { threshold: 0 });
    io.observe(atc);
    const footer = document.querySelector('.rr-footer');
    if (footer) {
      const fio = new IntersectionObserver((entries) => {
        footerVisible = entries.some((e) => e.isIntersecting);
        syncSticky();
      }, { threshold: 0 });
      fio.observe(footer);
    }
  }
  if (stickySubmit && form) stickySubmit.addEventListener('click', () => { if (!atc?.disabled && !stickySubmit.disabled) form.requestSubmit ? form.requestSubmit() : form.submit(); });
  setAvailability(atc ? !atc.disabled : true);
})();


/* Newsletter discount code copy */
(function () {
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-vg-copy-code]');
    if (!btn) return;
    const code = btn.getAttribute('data-vg-copy-code') || '';
    if (!code) return;
    const original = btn.textContent;
    try {
      await navigator.clipboard.writeText(code);
      btn.textContent = 'Copiato ✓';
    } catch (e) {
      const input = document.createElement('input');
      input.value = code;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); btn.textContent = 'Copiato ✓'; } catch (_) { btn.textContent = code; }
      input.remove();
    }
    window.setTimeout(() => { btn.textContent = original; }, 2200);
  });
})();

/* Cookie banner + Shopify Customer Privacy */
(function () {
  const root = document.querySelector('[data-vg-cookie-root]');
  if (!root) return;

  const prefs = root.querySelector('[data-vg-cookie-prefs]');
  const customizeBtn = root.querySelector('[data-vg-cookie-customize]');
  const saveBtn = root.querySelector('[data-vg-cookie-save]');
  const analyticsInput = root.querySelector('[data-vg-cookie-analytics]');
  const marketingInput = root.querySelector('[data-vg-cookie-marketing]');
  const KEY = 'vg_artikasa_cookie';

  function hideNativeShopifyBanner() {
    document.querySelectorAll('.shopify-pc__banner, .shopify-pc__prefs, .shopify-pc__prefs__overlay, #shopify-pc-banner, shopify-privacy-banner').forEach((el) => {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }
  hideNativeShopifyBanner();
  const nativeObserver = new MutationObserver(hideNativeShopifyBanner);
  nativeObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => nativeObserver.disconnect(), 20000);

  function markSettled() {
    document.documentElement.setAttribute('data-vg-cookie-state', 'done');
    document.dispatchEvent(new CustomEvent('vg:cookie-settled'));
  }

  function hide() {
    root.hidden = true;
    root.removeAttribute('data-vg-cookie-open');
  }

  function show(expanded) {
    root.hidden = false;
    root.setAttribute('data-vg-cookie-open', 'true');
    if (expanded) expand();
    const focusEl = root.querySelector('[data-vg-cookie-accept], [data-vg-cookie-save]');
    window.setTimeout(() => focusEl?.focus?.(), 30);
  }

  function expand() {
    if (prefs) prefs.hidden = false;
    if (customizeBtn) customizeBtn.hidden = true;
    if (saveBtn) saveBtn.hidden = false;
  }

  function stored() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function remember() {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function visitorConsent() {
    try { return window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || null; } catch (e) { return null; }
  }

  function hasShopifyDecision() {
    const c = visitorConsent();
    if (!c) return false;
    return ['analytics', 'marketing'].some((key) => c[key] === 'yes' || c[key] === 'no');
  }

  function syncToggles() {
    const c = visitorConsent();
    if (!c) return;
    if (analyticsInput) analyticsInput.checked = c.analytics === 'yes';
    if (marketingInput) marketingInput.checked = c.marketing === 'yes';
  }

  function apply(consent, done) {
    const payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: true,
      sale_of_data: false,
    };
    const finish = () => {
      remember();
      hide();
      markSettled();
      if (done) done();
    };
    const api = window.Shopify?.customerPrivacy;
    if (api?.setTrackingConsent) api.setTrackingConsent(payload, finish);
    else finish();
  }

  function ready(fn) {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      fn();
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      fn();
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => fn());
  }

  root.querySelector('[data-vg-cookie-accept]')?.addEventListener('click', () => {
    apply({ analytics: true, marketing: true });
  });
  root.querySelector('[data-vg-cookie-reject]')?.addEventListener('click', () => {
    apply({ analytics: false, marketing: false });
  });
  customizeBtn?.addEventListener('click', expand);
  saveBtn?.addEventListener('click', () => {
    apply({
      analytics: !!analyticsInput?.checked,
      marketing: !!marketingInput?.checked,
    });
  });

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-vg-cookie-open]');
    if (!openBtn) return;
    syncToggles();
    show(true);
  });

  ready(() => {
    if (hasShopifyDecision() || stored()) {
      hide();
      markSettled();
      return;
    }
    show(false);
  });
})();
